import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pay_ic_answer",
  "use": "icon-pay_ic_answer-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pay_ic_answer\"><g fill=\"#4bd214\"><path d=\"m12.8 0h-9.6c-1.767 0-3.2 1.433-3.2 3.2v9.6c0 1.767 1.433 3.2 3.2 3.2h9.6c1.767 0 3.2-1.433 3.2-3.2v-9.6c0-1.767-1.433-3.2-3.2-3.2z\" opacity=\".1\" /><path d=\"m8.848 3.432 3.496 9.136h-1.6l-.8-2.288h-3.856l-.8 2.288h-1.6l3.464-9.136zm.616 5.6-1.464-3.992-1.448 4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pay_ic_answer.svg
// module id = E9Ac
// module chunks = 87